const technologies = [
  { id: 1, title: "React Paginate", url:"https://www.npmjs.com/package/react-paginate" },
  { id: 2, title: "React", url:"https://reactjs.org/" },
  { id: 3, title: "Bootstrap 5", url:"https://getbootstrap.com/" },
  { id: 4, title: "React Router Dom", url:"https://reactrouterdotcom.fly.dev/docs/en/v6" },
]
export default technologies;